import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import DocentesView from './DocentesView';
import * as ROUTES from '../../../router/Routes';

const DocentesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.docentes}
      routes={[ROUTES.controlEstudios]}
    >
      <DocentesView />
    </ContainerTemplate>
  );
};

export default DocentesModule;
